import { CompanyProfileRouterPathEnum, MainMenuRouteEnum } from '@shared/enums';

export const DEFAULT_LOGGED_IN_PATH: string = MainMenuRouteEnum.Dashboard;
export const NOT_COMPLETE_LOGGED_IN_PATH: string =
  CompanyProfileRouterPathEnum.CompanyEmployeeViewRoot;
export const RESTRICTED_COMPANY_LOGGED_IN_PATH: string = '/project-request/general';
